import * as React from "react";
import styled from "react-emotion";

const StyledDiv = styled("div")`
    margin: 10px;
    font-size: 20px;
    font-weight: bold;
`;

const PageNotFound = () => {
    return <StyledDiv>404 Page Not Found</StyledDiv>;
};

export default PageNotFound;


// WEBPACK FOOTER //
// ./src/routes/ErrorPage/PageNotFound.tsx